import { useCallback, useMemo } from 'react';
import {
  BillingLabelOptionsQuery,
  useBillingLabelOptionsLazyQuery
} from 'graphql/types';
import { useNoteContext } from 'modules/notes/NoteContext';
import { ACTIVITY_BILLING_PAGE_COUNT } from '../components';

export interface BillingLabelSearchParams {
  query?: string;
  projectUri: string;
  taskUri?: string;
}

export interface UseBillingLabelSearchResultProps {
  searchHandler: (searchParams: BillingLabelSearchParams) => void;
  data: BillingLabelOptionsQuery | undefined;
  loading: boolean;
}

export const useBillingLabelSearch = (): UseBillingLabelSearchResultProps => {
  const { date } = useNoteContext();
  const [
    getLabelOptions,
    { data, loading }
  ] = useBillingLabelOptionsLazyQuery();

  const searchHandler = useCallback(
    ({ query, projectUri, taskUri }: BillingLabelSearchParams) => {
      const variables = {
        date: date.toISODate(),
        input: {
          count: ACTIVITY_BILLING_PAGE_COUNT,
          query: query,
          projectUri: projectUri,
          taskUri: taskUri
        }
      };

      getLabelOptions({ variables });
    },
    [date, getLabelOptions]
  );

  return useMemo(
    () => ({
      searchHandler,
      data,
      loading
    }),
    [data, loading, searchHandler]
  );
};
export default useBillingLabelSearch;
